import { useState } from 'react';
import { Link } from "react-router-dom";
import { Image } from 'semantic-ui-react';

import { FULL_STATUS_OPTIONS } from "../../../constants";
import { PATHS } from "../../../paths";

import { StatusUpdater } from '../../SessionUpdater';
import { PersonCourseAttendance } from '../../Protected/PersonCourseAttendance';

import styles from './TeacherSessionView.module.css';

const TeacherSessionView = ({ session, canEditCourse, refetchCourse }: { session: any, canEditCourse: any, refetchCourse: any }) => {
    const [triggerRefetch, setTriggerRefetch] = useState(true);

    if (!session) {
        return null;
    }

    // Check if the session startTime is in the last 3 days or if the startTime is in the next 60 minutes
    const isInRange =
        new Date(Number(session.startTime)) > new Date(Date.now() - 36 * 60 * 60 * 1000)
        && new Date(Number(session.startTime)) < new Date(Date.now() + 60 * 60 * 1000);


    // TODO: get the pending and absent to be colourful for teachers

    const pillifyStatus = (status: string | undefined) => {
        if (!status) return "";
        if (status.toLowerCase() === 'absent') {
            console.log("Absence detected");
        }
        console.log("Pillifying status:", status);
        switch (status.toLowerCase()) {
            case 'present':
                return <div className={styles.presentPill}>Present</div>;
            case 'absent':
                return <div className={styles.absentPill}>Absent</div>;
            default:
                return <div className={styles.otherPill}>{status}</div>;
        }
    }
    const renderAttendanceRow = (a: any) => (
        // for each attendance record, show the person's name as a link, photo, and status
        // photo on the left full height, name and attendance percentage on top right, status below
        <div key={a.id} style={{ padding: '1em', borderBottom: '1px solid #ddd', display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: a.isTeacher ? '#e6f7ff' : 'transparent' }}>
            <div style={{ float: 'left', marginRight: '1em' }}>
                <Image avatar src={a.user.photoUrl} size='tiny' style={{ width: '3em', height: '3em', objectFit: 'cover' }} />
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ fontSize: '1em', fontWeight: 'bold' }}>
                        <Link to={`${PATHS.PEOPLE}/${a.user.id}`} className={styles.link}>
                            {a.user.name} ({a.user.identifier})
                        </Link>
                    </div>
                    <div className={styles.attendance}>
                        {!a.isTeacher ? (<>
                            {" (Attendance: "}
                            <PersonCourseAttendance
                                personId={Number(a.user.id)}
                                triggerRefetch={triggerRefetch}
                                courseId={session.course.id} />
                            {")"}
                        </>
                        ) : 'Teacher'}
                    </div>
                </div>
                <div style={{ marginTop: '1em', fontSize: '1em' }}>
                    {(canEditCourse && isInRange) ? (
                        <StatusUpdater
                            refetch={() => {
                                setTriggerRefetch(!triggerRefetch)
                                refetchCourse();
                            }}
                            sessionId={session.id}
                            userId={a.user.id}
                            initStatus={a.status}
                            initDetails={a.details}
                        />
                    ) : (
                        <>
                            {FULL_STATUS_OPTIONS.find(s => s.value === a.status)?.text === 'Pending' ? (
                                new Date(Number(session.startTime)) > new Date(Date.now()) ? 'input available soon' : 'no data'
                            ) : pillifyStatus(FULL_STATUS_OPTIONS.find(s => s.value === a.status)?.text)}
                            {a.details?.length > 0 ? `: ${a.details}` : ''}
                        </>
                    )}
                </div>
            </div>
        </div>
    );

    const teachers = session.attendance.filter((a: any) => a.isTeacher);
    const students = session.attendance.filter((a: any) => !a.isTeacher);

    return (
        <div className={styles.sessionView}>
            {teachers.length > 0 && (
                <>
                    <div style={{ padding: '0.5em 1em', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.85em', color: '#555', backgroundColor: '#f5faff' }}>
                        Teachers
                    </div>
                    {teachers.map(renderAttendanceRow)}
                    <div style={{ padding: '0.5em 1em', marginTop: '0.5em', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.85em', color: '#555' }}>
                        Students
                    </div>
                </>
            )}
            {students.map(renderAttendanceRow)}
        </div>
    )
}

export { TeacherSessionView }
